var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gridworld-container"},[_c('Header'),_c(_vm.component,{tag:"component",attrs:{"grid":_vm.grid,"algo":_vm.algo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }